import { render, staticRenderFns } from "./ArticlePreviewCard.vue?vue&type=template&id=1e217f04&scoped=true&"
import script from "./ArticlePreviewCard.vue?vue&type=script&lang=js&"
export * from "./ArticlePreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePreviewCard.vue?vue&type=style&index=0&id=1e217f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e217f04",
  null
  
)

export default component.exports